// extracted by css-extract-rspack-plugin
export default {"Box":"chart-link-module__Box__JOdWv","PotentiallyDirty":"chart-link-module__PotentiallyDirty__Dp_pw"};